import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const SortIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_1111_19418)">
        <path d="M3 6.61719L13 6.61719" stroke={fillColor || '#9A9D9F'} />
        <path d="M5 8.61719L11 8.61719" stroke={fillColor || '#9A9D9F'} />
        <path d="M6 10.6172L10 10.6172" stroke={fillColor || '#9A9D9F'} />
      </g>
      <defs>
        <clipPath id="clip0_1111_19418">
          <rect width="16" height="16" fill={fillColor || 'white'} transform="translate(0 0.617188)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { SortIcon };
